export default function(){
  for(const categoryFilter of Array.from(document.querySelectorAll('.js-FiltersContainer'))){
    const filtersChoice = Array.from(categoryFilter.querySelectorAll('.js-Filters-choice'));
    let list = filtersChoice.slice(0, 7);
    const isVendorsFilter = categoryFilter.classList.contains('js-FiltersContainer--vendor');
    if(isVendorsFilter){
      const vendorsList = categoryFilter.querySelectorAll(".js-Filters-choice--vendor-fnacdarty");
      if(vendorsList.length > 0){
        list = vendorsList;
      }
    }

    for (const filterChoice of list) {
      filterChoice.classList.add("isActive");
    }
  }
}
